import { FormValidationResult } from "../../../../form/formValidation";
import { FieldGroup } from "../../../../form/FieldGroup";

export interface FileUploadProps {
  validation: FormValidationResult;
  title: React.ReactNode;
  fileUploads: React.ReactNode[];
}

export const FileUploadGroup: React.FC<FileUploadProps> = ({ title, validation, fileUploads }) => {
  return (
    <FieldGroup label={title} validation={validation} className="w-80-sm w-full-after-md">
      <div className="flex w-full gap-x-5">{fileUploads}</div>
    </FieldGroup>
  );
};
